import styled from "styled-components";
import {
  MovementListItemModel,
  MovementDetailModel,
  MovementDetailPhoneModel,
  MovementPhoneListItemModel,
  MovementListHeaderModel,
  NoMovementFoundModel,
} from "./model";
import { grey_1, grey_4, red } from "assets/strings/colors";

const MovementListItem = styled(MovementListItemModel)`
  #root & {
    margin: 0;
    padding: 0.7rem;
    cursor: pointer;
    border-radius: 1rem;
    ${(props) => {
      const selectedId = props.selectedMovement && props.selectedMovement._id;
      if (selectedId !== props.id) {
        return `border-bottom: 1px solid ${grey_4}}`;
      }
      return "";
    }};
    font-size: 0.9rem;
    display: flex;
    justify-content: center;
    align-items: center;
    > .period-section {
      text-align: center;
      padding: 0 0.5rem 0 0.5rem;
      width: 20%;
      > p {
        > span {
          text-transform: uppercase;
          font-weight: bold;
        }
        line-height: 2rem;
        margin: 0.1rem 0 0.1rem 0;
      }
    }
    > .amount-debit {
      text-align: center;
      padding: 0 0.5rem 0 0.5rem;
      width: 20%;
      margin: 0;
      color: ${red};
      font-size: 1rem;
    }
    > .amount-credit {
      text-align: center;
      padding: 0 0.5rem 0 0.5rem;
      width: 20%;
      margin: 0;
      font-size: 1rem;
    }
    > .tag {
      text-align: center;
      padding: 0 0.5rem 0 0.5rem;
      width: 20%;
      margin: 0;
      font-size: 0.8rem;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    > .user {
      padding: 0 0.5rem 0 0.5rem;
      width: 20%;
      margin: 0;
      text-align: center;
      > img {
        height: 1.5rem;
      }
    }
    > .status {
      padding: 0 0.5rem 0 0.5rem;
      width: 25%;
      margin: 0;
      text-align: center;
      > img {
        height: 1.5rem;
      }
      > .approved {
        text-transform: uppercase;
        font-weight: bold;
        color: #a2c400;
      }
      > .pending {
        text-transform: uppercase;
        font-weight: bold;
        color: #ffc107;
      }
      > .rejected {
        text-transform: uppercase;
        font-weight: bold;
        color: #ff0000;
      }
      > .debit {
        text-transform: uppercase;
        font-weight: bold;
        color: #ff0000;
      }
    }
  }
`;
const MovementDetail = styled(MovementDetailModel)`
  #root & {
    margin: 0;
    cursor: pointer;
    border-radius: 1rem;
    ${(props) => {
      const selectedId = props.selectedMovement && props.selectedMovement._id;
      if (selectedId === props.id) {
        return `border-bottom: 1px solid ${grey_4}}`;
      }
      return "";
    }};
    :hover {
      background: ${grey_1};
    }
    font-size: 0.9rem;
    justify-content: center;
    align-items: center;
    > .header {
      align-items: center;
      > .col {
        margin: 1.5rem 0.5rem 0 0.5rem;
        padding-bottom: 0.3rem;
        display: inline-block;
        text-transform: uppercase;
        text-align: center;
        font-weight: bold;
        border-bottom: 1px solid ${grey_4};
      }
      > .fifty {
        width: calc(50% - 1rem);
      }
      > .twenty-five {
        width: calc(25% - 1rem);
      }
      > .thirty {
        width: calc(30% - 1rem);
      }
      > .twenty {
        width: calc(20% - 1rem);
      }
      > .hundred {
        width: calc(100% - 1rem);
      }
    }
    > .item {
      align-items: center;
      > .col {
        margin: 0.5rem 0.5rem 1rem 0.5rem;
        padding-bottom: 0.3rem;
        display: inline-block;
        font-size: 0.9rem;
        text-align: center;
      }

      > .fifty {
        width: calc(50% - 1rem);
      }
      > .twenty {
        width: calc(20% - 1rem);
      }
      > .thirty {
        width: calc(30% - 1rem);
      }
      > .twenty-five {
        width: calc(25% - 1rem);
        > span {
          color: blue;
        }
      }
      > .hundred {
        width: calc(100% - 1rem);
      }
    }
  }
`;

const MovementPhoneListItem = styled(MovementPhoneListItemModel)`
  #root & {
    margin: 0;
    padding: 0.7rem;
    font-size: 0.85rem;
    cursor: pointer;
    border-radius: 1rem;
    ${(props) => {
      const selectedId = props.selectedMovement && props.selectedMovement._id;
      if (selectedId !== props.id) {
        return `border-bottom: 1px solid ${grey_4}}`;
      }
      return "";
    }};
    > .title {
      display: inline-block;
      margin-bottom: 0.3rem;
      text-transform: uppercase;
      font-size: 1.1rem;
      border-bottom: 1px solid ${grey_4};
    }
    .status {
      float: right;
      height: 2rem;
    }
    > p {
      margin: 0 0 0.6rem 0;
    }
  }
`;
const MovementDetailPhone = styled(MovementDetailPhoneModel)`
  #root & {
    margin: 0;
    font-size: 0.85rem;
    cursor: pointer;
    border-radius: 1rem;
    ${(props) => {
      const selectedId = props.selectedMovement && props.selectedMovement._id;
      if (selectedId === props.id) {
        return `border-bottom: 1px solid ${grey_4}}`;
      }
      return "";
    }};
    :hover {
      background: ${grey_1};
    }
    > .header {
      align-items: center;
      > .col {
        margin: -2rem 0.5rem 0 0.5rem;
        padding-bottom: 0.3rem;
        display: inline-block;
        text-transform: uppercase;
        text-align: center;
        font-weight: bold;
        border-bottom: 1px solid ${grey_4};
      }
      > .fifty {
        width: calc(50% - 1rem);
      }
      > .twenty-five {
        width: calc(25% - 1rem);
      }
      > .thirty {
        width: calc(30% - 1rem);
      }
      > .twenty {
        width: calc(20% - 1rem);
      }
      > .hundred {
        width: calc(100% - 1rem);
      }
    }
    > .item {
      align-items: center;
      > .col {
        margin: 0.5rem 0.5rem 1rem 0.5rem;
        padding-bottom: 0.3rem;
        display: inline-block;
        font-size: 0.9rem;
        text-align: center;
      }

      > .fifty {
        width: calc(50% - 1rem);
      }
      > .twenty {
        width: calc(20% - 1rem);
      }
      > .thirty {
        width: calc(30% - 1rem);
      }
      > .twenty-five {
        width: calc(25% - 1rem);
      }
      > .hundred {
        width: calc(100% - 1rem);
        > span {
          color: blue;
        }
      }
    }
    > .line {
      margin: -1.5rem 0.7rem 0 0.7rem;
      padding-bottom: 0.7rem;
      font-size: 1.1rem;
      text-transform: uppercase;
      text-align: center;
      border-bottom: 1px solid ${grey_4};
    }
    > .row {
      margin: 0;
      cursor: pointer;
      padding: 0.7rem;
      > .title {
        display: inline-block;
        margin-bottom: 0.3rem;
        text-transform: uppercase;
        font-size: 1.1rem;
        border-bottom: 1px solid ${grey_4};
      }
    }
  }
`;

const MovementListHeader = styled(MovementListHeaderModel)`
  #root & {
    margin: 0;
    > .col {
      margin: 1.2rem 0.5rem 0 0.5rem;
      padding-bottom: 0.3rem;
      display: inline-block;
      text-transform: uppercase;
      text-align: center;
      font-weight: bold;
      border-bottom: 1px solid ${grey_4};
    }
    > .forty {
      width: calc(40% - 1rem);
    }
    > .twenty {
      width: calc(20% - 1rem);
    }
    > .twenty-five {
      width: calc(25% - 1rem);
    }
  }
`;

const NoMovementFound = styled(NoMovementFoundModel)`
  #root & {
    text-align: center;
    font-size: 1.2rem;
    line-height: 62px;
  }
`;

export {
  MovementListItem,
  MovementDetail,
  MovementDetailPhone,
  MovementListHeader,
  NoMovementFound,
  MovementPhoneListItem,
};
